import {classNames} from "shared/lib/classNames/classNames";
import cls from "./ContactPage.module.scss";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Logo from "shared/assets/icons/CuttedDecoration.svg";


const ContactPage = () => {
    return (
        <div id={"contactPage"} className={classNames(cls.ContactPage, {}, [])}>
            <section className={classNames("page-section", {}, [cls.ContactPage__contact])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.HeaderBlock}>
                        <Title className={cls.CareerPage__title} sentences={["Contact Us"]}
                               colors={[TitleTheme.NEUTRAL]}/>
                        <div className={cls.HeaderBlock__subtitle}>
                            <a href="mailto:info@hyperadlab.com">info@hyperadlab.com </a>
                            - general questions
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ContactPage;
